import { _,moment } from '../../../vendor'
import { Notification,Biscuit } from '../../utils'
import InboomaBaseView from '../InboomaBaseView'
import InboomaBaseCollectionView from '../InboomaBaseCollectionView'

import PaginationBehavior from '../../behaviors/Behavior.Pagination'

import VoucherTypeItemTpl from '../../templates/vouchers/VoucherTypeItemTpl.html'

const VouchersTypeView = InboomaBaseView.extend({

    template : VoucherTypeItemTpl,
    className : 'inb-c-item-details-row inb-c-item--voucher-types row',

    ui : {
        removeVoucherType: '.inb-voucher-type-remove',
        voucherTypeStatusSwitch: '.voucher-type-status-switch'
    },

    templateContext () {
        return {
            moment,
            client_id: Biscuit.get('user.client_id')
        }
    },

    events : {
        'click @ui.removeVoucherType' : '_removeVoucherType',
        'click @ui.voucherTypeStatusSwitch' : '_changeVoucherTypeStatus'
    },

    onRender () {
        this.$el.attr('title', );
    },

    _stateChangeInProgress : false,

    _changeVoucherTypeStatus () {
        // ev.preventDefault() would dismiss the CSS-animation,
        // we therefore check for running requests locally
        // using this._stateChangInProgress

        if (this._stateChangeInProgress) return;

        this._stateChangeInProgress = true;

        const that = this;

        this.model.save({ status: !this.model.get('status') }, {
            patch: true,
            success () {
                that._stateChangeInProgress = false;

                new Notification({
                    message: that.t('voucher_type_status_updated'),
                    duration: 5000,
                    closeable: true,
                    icon: 'fi fi-torso'
                });

                that.render();
            }
        })
    },

    _removeVoucherType (ev) {

        ev.preventDefault();

        const that = this;

        let rights = {
            'user': 0,
            'manager': 1,
            'admin': 2
        };

        const role = Biscuit.get('user.role'),
            targetRole = this.model.get('role');

        if (rights[role] > rights[targetRole]) {
            if (confirm(this.t('really_remove'))) {
                this.model.destroy({
                    success: function (model, repsonse) {

                        that.$el.fadeOut('fast');
                        new Notification({
                            message: that.t('removed_${a}', {a: that.t('voucher_type')}, 'capital'),
                            duration: 5000,
                            closeable: true,
                            icon: 'fi fi-trash'
                        });

                    }
                });
            }
        } else {
            new Notification({
                message: that.t('cannot_remove_${a}', {a: that.t('voucher_type')}, 'capital'),
                duration: 5000,
                closeable: true,
                icon: 'fi fi-trash'
            });
        }
    },

});

export default InboomaBaseCollectionView.extend({

    childView: VouchersTypeView,
    template: _.noop,

    behaviors : [
        {
            behaviorClass: PaginationBehavior
        }
    ],

    initialize () {
        console.log("filter by type: ",this.options.type);
        this.collection.filterByType([this.options.type]);

        InboomaBaseCollectionView.prototype.initialize.apply(this);
        this.$el.html('');
        this.render();
    }

});
